import { GROUP_URL } from 'src/config/api.config';
import ApiService from './Api.service';

class GroupService extends ApiService {
  constructor() {
    super(GROUP_URL);
  }
  getGroupSummary = async (params) => {
    return this.doGet(
      `${GROUP_URL}/summary`,
      { ...params },
      { ...this._headers }
    );
  };
}

export default new GroupService();
